import { PlusOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import { Button, Col, Form, FormInstance, Row, Select } from "antd";
import { FC, useState } from "react";
import { useIntl } from "react-intl";
import PackagesSVG from "../../../assets/catalog/PackagesSVG";
import DeleteSVG from "../../../assets/common/DeleteSVG";
import { adminGetPackagesWithCategories } from "../../../network/admin";
import { getAllPackagesWithCategories } from "../../../network/package";
import { queryKeys } from "../../../services/react-query/queryKeys";

interface PackagesWithCategoriesSelectProps {
  selectedPackages: {
    id: number;
    name: string;
    retail_price: string;
    total_time: string;
  }[];
  setSelectedPackages: React.Dispatch<
    React.SetStateAction<
      {
        id: number;
        name: string;
        retail_price: string;
        total_time: string;
      }[]
    >
  >;
  selectedLocations: {
    id: number;
    key: number;
  }[];

  config: {
    isAdmin?: boolean;
    teamMemberId?: number;
    locationId: number;
    locationName?: string;
    isEdit?: boolean;
    salonName?: string;
  };
  form: FormInstance<any>;
}

const PackagesWithCategoriesSelect: FC<PackagesWithCategoriesSelectProps> = ({
  selectedPackages,
  setSelectedPackages,
  form,

  selectedLocations,
  config,
}) => {
  console.log(config, "config");
  const intl = useIntl();
  const { data: packages, isLoading } = useQuery(
    [queryKeys.listPackages, config?.locationId],
    () => {
      if (config?.isAdmin) {
        return adminGetPackagesWithCategories(config?.locationId);
      } else {
        return getAllPackagesWithCategories(config?.locationId);
      }
    },
    {
      enabled: !!config?.locationId,
      select: (res) => {
        const data: any[] = [];
        res?.data?.map((category: { services: any[]; packages: any[] }) => {
          if (category?.packages?.length > 0) {
            data.push(category);
          }
        });
        return data;
      },
    }
  );
  const packagesCategoriesOptions = Array.isArray(packages)
    ? packages?.map((category) => ({
        label: category?.name,
        value: category?.id,
        key: category?.id,
      }))
    : [];

  const [selectedPackageCategoryId, setSelectedPackageCategoryId] = useState<
    null | number
  >(null);
  const getPackagesOptions = () => {
    const categoryPackages = packages?.find(
      (pkg: {
        id: number;
        name: string;
        packages: Array<{
          name: string;
          id: number;
          total_time: string;
          retail_price: string;
        }>;
      }) => pkg?.id === selectedPackageCategoryId
    );

    if (categoryPackages) {
      return categoryPackages?.packages?.map(
        (packageItem: {
          name: string;
          id: number;
          total_time: string;
          retail_price: string;
        }) => ({
          label: packageItem?.name,
          value: packageItem?.id,
          key: packageItem?.id,
          disabled: !!selectedPackages.find(
            (selectedPackage) => selectedPackage?.id === packageItem?.id
          ),
        })
      );
    } else {
      return [];
    }
  };

  return (
    <Form.List name="packages">
      {(fields, { add, remove }) => (
        <>
          <Form.Item className="w-full p-2 rounded bg-color-light-gr text-color-primary">
            <div>
              <Row className="mb-4">
                <Col
                  className="gutter-row"
                  xl={24}
                  lg={8}
                  xs={24}
                  sm={24}
                  span={11}
                >
                  <label className="text-color-primary">
                    {intl.formatMessage({
                      id: "packagesByMember",
                    })}
                  </label>
                </Col>
              </Row>

              {fields.map(({ key, name, ...restField }, index) => (
                <Row key={key} gutter={{ xs: 8, sm: 16, md: 24, lg: 15 }}>
                  <Col
                    className="gutter-row"
                    xl={11}
                    lg={11}
                    xs={22}
                    sm={10}
                    span={10}
                  >
                    <Form.Item
                      {...restField}
                      required={false}
                      label={intl.formatMessage({
                        id: "package_category_label",
                      })}
                      rules={[
                        {
                          required: true,
                          message: intl.formatMessage({
                            id: "package_category_required_message",
                          }),
                        },
                      ]}
                    >
                      <Select
                        loading={isLoading}
                        placeholder={intl.formatMessage({
                          id: "package_category_placeholder",
                        })}
                        className="w-full my-input"
                        options={packagesCategoriesOptions}
                        onChange={(value) => {
                          setSelectedPackageCategoryId(value);
                        }}
                      />
                    </Form.Item>
                  </Col>

                  <Col
                    className="gutter-row"
                    xl={11}
                    lg={11}
                    xs={22}
                    sm={10}
                    span={10}
                  >
                    <Form.Item
                      {...restField}
                      required={false}
                      name={["packages"]}
                      label={intl.formatMessage({
                        id: "package",
                      })}
                      // rules={[{ required: true, message: "اختر الخدمة " }]}
                    >
                      <Select
                        loading={isLoading}
                        placeholder={intl.formatMessage({
                          id: "select_package",
                        })}
                        options={getPackagesOptions()}
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    className="gutter-row"
                    xl={2}
                    lg={2}
                    xs={2}
                    sm={4}
                    span={2}
                  >
                    <Form.Item label=" ">
                      <Button
                        className="bg-transparent border-none shadow-none outline-none"
                        onClick={() => {
                          const selectedPackageId = form.getFieldValue([
                            "packages",
                          ])["packages"];
                          if (!selectedPackageId) {
                            return false;
                          }
                          const existedPackage = selectedPackages?.find(
                            (pkg) => pkg?.id === parseInt(selectedPackageId)
                          );
                          if (existedPackage) return;
                          const categoryPackages = packages?.find(
                            (pkg: {
                              id: number;
                              name: string;
                              packages: Array<{
                                name: string;
                                id: number;
                                total_time: string;
                                retail_price: string;
                              }>;
                            }) => pkg?.id === selectedPackageCategoryId
                          );
                          if (!categoryPackages) return;

                          const newPackage = categoryPackages?.packages?.find(
                            (service: {
                              id: number;
                              name: string;
                              total_time: string;
                              price: string;
                            }) => service?.id === parseInt(selectedPackageId)
                          );
                          if (!newPackage) return;
                          setSelectedPackages([
                            ...selectedPackages,
                            {
                              id: newPackage?.id,
                              name: newPackage?.name,
                              total_time: newPackage?.total_time,
                              retail_price: newPackage?.retail_price,
                            },
                          ]);
                          form.resetFields(["packages", index]);
                        }}
                        block
                        icon={
                          <PlusOutlined className="bg-[#00086D] text-white p-1 rounded-md" />
                        }
                      ></Button>
                    </Form.Item>
                  </Col>
                </Row>
              ))}
              <div>
                {selectedPackages.map((pkg) => (
                  <>
                    <div
                      key={pkg?.id}
                      className="flex justify-between gap-2 p-1 px-2 my-1 bg-white rounded"
                    >
                      <div className="flex items-center justify-between w-full ">
                        <div className="flex items-center justify-between w-full gap-8">
                          <p className="flex gap-2 items-center w-[180px]">
                            <PackagesSVG />
                            <span>{pkg.name}</span>
                          </p>
                          <p className="flex gap-1 items-center w-[70px]">
                            <span>{pkg?.total_time}</span>
                            <small className="self-center mt-2 text-xs">
                              {" "}
                              {intl.formatMessage({
                                id: "minutes",
                                defaultMessage: "دقيقة",
                              })}
                            </small>
                          </p>
                          <p className="flex gap-1 items-center w-[70px]">
                            <span>{pkg?.retail_price}</span>
                            <small className="self-center mt-2 text-xs">
                              {intl.formatMessage({
                                id: "SAR",
                                defaultMessage: "ريال سعودي",
                              })}
                            </small>
                          </p>
                        </div>
                      </div>

                      <Button
                        type="text"
                        htmlType="button"
                        onClick={() => {
                          const newPackages = selectedPackages.filter(
                            (p) => p?.id !== pkg?.id
                          );
                          setSelectedPackages(newPackages);
                        }}
                      >
                        <DeleteSVG />
                      </Button>
                    </div>
                  </>
                ))}
              </div>
            </div>
          </Form.Item>
        </>
      )}
    </Form.List>
  );
};

export default PackagesWithCategoriesSelect;
